import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Nav,
  Label,
} from "reactstrap";
import { NavLink as BreadcrumbNavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import TimezoneSelect from "react-timezone-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import "moment-timezone";
import { MainContext } from "context/MainContext.js";
import Switch from "react-bootstrap-switch";
import SelectComponent from "components/Utils/select.js";
LoadingOverlay.propTypes = undefined;
import ReactTable from "components/ReactTable/ReactTable.js";
import { installationRoles } from "data/users.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const UserEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);
  const [horizontalTabs, setHorizontalTabs] = useState("general");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [alert, setAlert] = useState(null);
  const [selectedInstallationRole, setSelectedInstallationRole] = useState("");

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["admin.users.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const alarmLevels = [
    { value: "", label: "Disabled" },
    { value: "40", label: "Critical (CR)" },
    { value: "30", label: "Major (MJ)" },
    { value: "20", label: "Minor (MN)" },
    { value: "0", label: "Non-Alarm (NA)" },
  ];

  const [groupValues, setGroupValues] = useState({
    id: "",
    name: "",
    description: "",
  });

  const handleGroupCheckbox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedGroups((selectedSubgroups) => [...selectedSubgroups, value]);
    } else {
      setSelectedGroups((subgroup) => subgroup.filter((v) => v !== value));
    }
  };

  let formError = false;

  // Object containing all the form values
  const [values, setValues] = useState({
    username: "",
    fullname: "",
    email: "",
    sessionTimeout: 0,
    enabled: true,
    isDevice: false,
    isRadius: false,
    privilegeLevel: 5,
    timezone: "America/Montreal",
    password: "",
    confirmPassword: "",
    notificationAlarmLevel: "",
    permGamPortalAccess: true,
    installationRole: "",
  });

  // Object containing all error messages for every inputs
  const [states, setStates] = useState({
    username: "",
    fullname: "",
    email: "",
    sessionTimeout: "",
    enabled: "",
    isDevice: "",
    privilegeLevel: "",
    timezone: "",
    password: "",
    confirmPassword: "",
    notificationAlarmLevel: "",
    permGamPortalAccess: "",
    installationRole: "",
  });

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    // Validate all the field before calling the API
    if (mode == "create") {
      setStates({
        ...states,
        ["username"]: validateField("username"),
        ["email"]: validateField("email"),
        ["sessionTimeout"]: validateField("sessionTimeout"),
        ["enabled"]: validateField("enabled"),
        ["isDevice"]: validateField("isDevice"),
        ["privilegeLevel"]: validateField("privilegeLevel"),
        ["timezone"]: validateField("timezone"),
        ["password"]: validateField("password"),
        ["confirmPassword"]: validateField("confirmPassword"),
      });

      if (values["privilegeLevel"] > 1 && values["isDevice"]) {
        formError = true;
        setStates({
          ...states,
          ["privilegeLevel"]:
            "Device type user cannot have privilege level higher than 1",
        });
      }
    } else if (mode == "edit") {
      setStates({
        ...states,
        ["email"]: validateField("email"),
        ["sessionTimeout"]: validateField("sessionTimeout"),
        ["enabled"]: validateField("enabled"),
        ["isDevice"]: validateField("isDevice"),
        ["privilegeLevel"]: validateField("privilegeLevel"),
        ["timezone"]: validateField("timezone"),
      });

      if (values["privilegeLevel"] > 1 && values["isDevice"]) {
        formError = true;
        setStates({
          ...states,
          ["privilegeLevel"]:
            "Device type user cannot have privilege level higher than 1",
        });
      }
    } else if (mode == "delete") {
      setStates({
        ...states,
        ["password"]: validateField("password"),
        ["confirmPassword"]: validateField("confirmPassword"),
      });
    }

    if (!formError) {
      postData();
    }
  };

  // Validate if field is empty
  const validateField = (field) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const [params, setParams] = useState(location.state?.value ?? "");
  const [mode, setMode] = useState(location.state ? location.state.mode : "");

  useEffect(() => {
    if (mode == "edit") {
      fetchEditData();
    } else if (mode == "password") {
      fetchPasswordEditData();
    } else if (mode == "create") {
      fetch("/api/v1/user/create", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
        },
      })
        .then((response) => response.json())
        .then((actualData) => {
          setDefaultInstallationRole("");
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }, [mode]);

  const fetchEditData = () => {
    setShowLoading(true);
    const start = Date.now();

    fetch("/api/v1/user/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        username: params.split("||")[1],
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          setValues(actualData.data.user);
          setDefaultInstallationRole(actualData.data.user.installationRole);
        }
        actualData.data.user.groups.map((group) => {
          setSelectedGroups((selectedGroup) => [...selectedGroup, group]);
        });
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const setDefaultInstallationRole = (defaultValue) => {
    installationRoles.forEach((item) => {
      if (item.value == defaultValue || (!defaultValue && item.value == "")) {
        setSelectedInstallationRole(item);
        setValues((prevState) => ({
          ...prevState,
          ["installationRole"]: defaultValue,
        }));
      }
    });
  };

  const fetchPasswordEditData = () => {
    setShowLoading(true);
    const start = Date.now();

    fetch("/api/v1/user/password/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        username: params.split("||")[1],
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          setValues(actualData.data.user);
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "";
    let apiMethod = "";
    if (mode == "edit") {
      apiUrl = "/api/v1/user/edit";
      apiMethod = "PUT";
    } else if (mode == "create") {
      apiUrl = "/api/v1/user/create";
      apiMethod = "POST";
    } else if (mode == "password") {
      apiUrl = "/api/v1/user/password/edit";
      apiMethod = "PUT";
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        username: values.username,
        fullname: values.fullname,
        email: values.email,
        sessionTimeout: values.sessionTimeout,
        enabled: values.enabled,
        privilegeLevel: values.privilegeLevel,
        timezone: values.timezone,
        password: values.password,
        confirmPassword: values.confirmPassword,
        notificationAlarmLevel: values.notificationAlarmLevel,
        permGamPortalAccess: values.permGamPortalAccess,
        groups: selectedGroups,
        installationRole: values.installationRole,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error(
            mode == "password"
              ? "A problem occured while changing the password"
              : "A problem occured while saving the user",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          setErrorMsg([]);
          toast.success(
            mode == "password"
              ? "Password changed successfully"
              : "User saved successfully",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );

          // If a user is created successfully, switch to edit mode on the same user
          if (mode == "create") {
            setParams("username||" + values.username);
            setMode("edit");
          } else if (mode == "password") {
            setValues({
              ...values,
              ["password"]: "",
              ["confirmPassword"]: "",
            });
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleNotificationChange = (type, e) => {
    setValues({
      ...values,
      [type]: e.value.value,
    });
  };

  const handleTimezone = (e) => {
    var timezone = e.value;

    setValues({
      ...values,
      ["timezone"]: timezone,
    });
  };

  const handleSwitchChange = (e) => {
    const { props, state } = e;
    setValues({
      ...values,
      [props.name]: state.value,
    });
  };

  const handleInstallationRoleChange = (option) => {
    setValues({
      ...values,
      ["installationRole"]: option.value.value,
    });
    setSelectedInstallationRole(option);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const groupColumns = [
    {
      Header: "",
      accessor: "actions",
      sortable: false,
      filterable: false,
      flex: "0 1 5%",
      Cell: (props) => {
        return props.row.original.id == groupValues.id || mode == "view" ? (
          ""
        ) : (
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  value={props.row.original.id}
                  checked={selectedGroups.includes(props.row.original.id)}
                  onChange={handleGroupCheckbox}
                />
                <span className="form-check-sign" />
              </Label>
            </FormGroup>
          </div>
        );
      },
    },
    {
      Header: "Group Name",
      accessor: "name",
      sortBy: "name",
      flex: "1 1 0",
    },
    {
      Header: "Group Description",
      accessor: "description",
      sortBy: "description",
      flex: "1 1 0",
    },
    {
      Header: "Sub Groups",
      accessor: "subgroups",
      sortBy: "subgroups",
      flex: "1 1 0",
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="content">
        {alert}
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <BreadcrumbNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </BreadcrumbNavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <BreadcrumbNavLink
                      to={{
                        pathname: "/admin/users/list",
                      }}
                    >
                      Users
                    </BreadcrumbNavLink>
                    {params.includes("username") ? (
                      <i>&lt;{params.split("||")[1]}&gt;</i>
                    ) : (
                      ""
                    )}
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    {mode == "create" ? "Create" : ""}
                    {mode == "edit" ? "Edit" : ""}
                    {mode == "password" ? "Change password" : ""}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "general"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "general" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("general")}
                        >
                          General
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "permissions"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "permissions" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("permissions")}
                        >
                          Permissions
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "notifications"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "notifications" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("notifications")}
                        >
                          Notification
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "groups"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "groups" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("groups")}
                        >
                          Groups
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>
                <Form onSubmit={handleSubmit}>
                  <TabContent
                    id="my-tab-content"
                    activeTab={horizontalTabs}
                    style={{ paddingLeft: "20px" }}
                  >
                    <TabPane tabId="general" role="tabpanel">
                      <CardBody>
                        {errorMsg && errorMsg.length > 0 ? (
                          <div
                            style={{
                              backgroundColor: "#FFC0A4",
                              border: "1px solid #ef8157",
                              color: "#66615b",
                              paddingTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            <ul>
                              <li>{errorMsg}</li>
                            </ul>
                          </div>
                        ) : (
                          ""
                        )}

                        <Row>
                          <Col>
                            <label>Username</label>
                            <FormGroup
                              className={
                                states["username"].length !== 0
                                  ? "has-danger"
                                  : ""
                              }
                            >
                              <Input
                                placeholder="Enter username"
                                type="username"
                                name="username"
                                onChange={handleInputChange}
                                value={values ? values.username : ""}
                                readOnly={mode == "create" ? false : true}
                              />
                              <label className="error">
                                {states["username"]}
                              </label>
                            </FormGroup>
                          </Col>
                          <Col>
                            {mode != "password" ? (
                              <>
                                <label>Full Name</label>
                                <FormGroup
                                  className={
                                    states["fullname"].length !== 0
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <Input
                                    placeholder="Enter full name"
                                    type="fullname"
                                    name="fullname"
                                    onChange={handleInputChange}
                                    value={values ? values.fullname : ""}
                                  />
                                  <label className="error">
                                    {states["fullname"]}
                                  </label>
                                </FormGroup>
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col>
                            <>
                              <label>Email address</label>
                              <FormGroup
                                className={
                                  states["email"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  placeholder="Enter email"
                                  type="email"
                                  name="email"
                                  onChange={handleInputChange}
                                  value={values ? values.email : ""}
                                />
                                <label className="error">
                                  {states["email"]}
                                </label>
                              </FormGroup>
                            </>
                          </Col>
                        </Row>
                        {mode != "password" ? (
                          <Row>
                            {" "}
                            <Col>
                              <label>Privilege Level</label>
                              <FormGroup
                                className={
                                  states["privilegeLevel"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  type="number"
                                  name="privilegeLevel"
                                  min="0"
                                  max="15"
                                  onChange={handleInputChange}
                                  readOnly={
                                    mode == "edit" && values.isRadius
                                      ? true
                                      : false
                                  }
                                  value={values ? values.privilegeLevel : 0}
                                />
                                <label className="error">
                                  {states["privilegeLevel"]}
                                </label>
                              </FormGroup>
                            </Col>
                            <Col>
                              <SelectComponent
                                label="Installation Role"
                                fieldName={"installationRole"}
                                array={installationRoles}
                                stateValue={states["installationRole"]}
                                onChange={(option) => {
                                  handleInstallationRoleChange(option);
                                }}
                                selectedOption={selectedInstallationRole}
                              />
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                        {mode != "password" ? (
                          <Row>
                            <Col>
                              <label>Session Timeout (minutes)</label>
                              <FormGroup
                                className={
                                  states["sessionTimeout"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  type="number"
                                  name="sessionTimeout"
                                  min="0"
                                  onChange={handleInputChange}
                                  value={values ? values.sessionTimeout : 0}
                                />
                                <label className="error">
                                  {states["sessionTimeout"]}
                                </label>
                              </FormGroup>
                            </Col>
                            <Col>
                              <label>Timezone</label>
                              <FormGroup
                                className={
                                  states["timezone"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <TimezoneSelect
                                  value={values ? values.timezone : ""}
                                  name="timezone"
                                  onChange={handleTimezone}
                                />

                                <label className="error">
                                  {states["timezone"]}
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}

                        {mode == "edit" ? (
                          ""
                        ) : (
                          <Row>
                            <Col>
                              <label>Password</label>
                              <FormGroup
                                className={
                                  states["password"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  placeholder="Enter password"
                                  type="password"
                                  name="password"
                                  onChange={handleInputChange}
                                  value={values ? values.password : ""}
                                />
                                <label className="error">
                                  {states["password"]}
                                </label>
                              </FormGroup>
                            </Col>
                            <Col>
                              <label>Confirm password</label>
                              <FormGroup
                                className={
                                  states["confirmPassword"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  placeholder="Confirm password"
                                  type="password"
                                  name="confirmPassword"
                                  onChange={handleInputChange}
                                  value={values ? values.confirmPassword : ""}
                                />
                                <label className="error">
                                  {states["confirmPassword"]}
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                        )}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="notifications" role="tabpanel">
                      <CardBody>
                        <Row>
                          <Col>
                            <FormGroup className={"settingLabel"}>
                              {values["username"] != "" ? (
                                <SelectComponent
                                  label="Alarms (Lowest Level)"
                                  fieldName={"alarmNotificationField"}
                                  array={alarmLevels}
                                  defaultValue={alarmLevels.find(
                                    ({ value }) =>
                                      value ===
                                      values["notificationAlarmLevel"],
                                  )}
                                  onChange={(option) => {
                                    handleNotificationChange(
                                      "notificationAlarmLevel",
                                      option,
                                    );
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </FormGroup>
                          </Col>
                          <Col></Col>
                          <Col></Col>
                        </Row>
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="permissions" role="tabpanel">
                      <CardBody>
                        <Row>
                          <Col>
                            <label className={"settingLabel"}>
                              GAM Portal Access
                            </label>
                            <FormGroup>
                              <Switch
                                name="permGamPortalAccess"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={values.permGamPortalAccess}
                              />
                            </FormGroup>
                          </Col>
                          <Col></Col>
                          <Col></Col>
                        </Row>
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="groups" role="tabpanel">
                      <CardBody>
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#000000",
                            marginBottom: "12px",
                          }}
                        >
                          <i
                            className="nc-icon nc-alert-circle-i"
                            style={{ marginRight: "6px" }}
                          />
                          Select the groups this user will have access to.
                          Selections only take effect when{" "}
                          <strong>Groups Access Mode</strong> is enabled under{" "}
                          <a
                            href="/admin/settings/edit"
                            style={{
                              color: "#6c757d",
                              textDecoration: "underline",
                            }}
                          >
                            Admin &gt; Settings
                          </a>
                          .
                        </p>
                        <ReactTable
                          query="/api/v1/group/list"
                          columns={groupColumns}
                          title="Groups"
                          className="-striped -highlight primary-pagination"
                          subtable="true"
                        />
                      </CardBody>
                    </TabPane>
                    <Button className="btn-round" color="info" type="submit">
                      Submit
                    </Button>
                  </TabContent>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserEdit;
